import { AnnotationNavigationButtons } from "./AnnotationNavigationButtons";
import { LogicalOperator } from "./LogicalOperator";
/**
 * Props for the AnnotationNavigationHeader component.
 */
interface AnnotationNavigationHeaderProps {
  currentClauseIndex: number;
  totalClauseCount: number;
  canRemoveClause: boolean;
  canAddNewClause: boolean;
  disabled?: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onRemove: () => void;
  onAdd: (logicalOperator: LogicalOperator) => void;
}

/**
 * Header showing current clause index and navigation controls.
 *
 * @param props - Destructured parameter object
 * @param props.currentClauseIndex - Index of the current clause
 * @param props.totalClauseCount - Total number of clauses
 * @param props.canRemoveClause - Whether the current clause can be removed
 * @param props.canAddNewClause - Whether a new clause can be added
 * @param props.disabled - Optional disabled flag
 * @param props.onPrevious - Handler to move to previous clause
 * @param props.onNext - Handler to move to next clause
 * @param props.onRemove - Handler to remove current clause
 * @param props.onAdd - Handler to add a new clause with given logical operator
 */
export const AnnotationNavigationHeader = ({
  currentClauseIndex,
  totalClauseCount,
  canRemoveClause,
  canAddNewClause,
  disabled = false,
  onPrevious,
  onNext,
  onRemove,
  onAdd,
}: AnnotationNavigationHeaderProps): React.ReactElement => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <strong>
          Annotation {currentClauseIndex + 1} of {totalClauseCount}
        </strong>
      </div>
      <AnnotationNavigationButtons
        currentClauseIndex={currentClauseIndex}
        totalClauseCount={totalClauseCount}
        canRemoveClause={canRemoveClause}
        canAddNewClause={canAddNewClause}
        disabled={disabled}
        onPrevious={onPrevious}
        onNext={onNext}
        onRemove={onRemove}
        onAdd={onAdd}
      />
    </div>
  );
};

AnnotationNavigationHeader.displayName = "AnnotationNavigationHeader";
